/*
 * @Author: zhaoyian zhaopeng1957462481@163.com
 * @Date: 2023-11-14 15:47:56
 * @LastEditors: zhaoyian zhaopeng1957462481@163.com
 * @LastEditTime: 2023-11-23 21:39:43
 * @FilePath: \yunque\src\server\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { axios } from '@/utils/request'

export function useEnterprise(data) {
    return axios({
        url: '/api/MTWSPlantform/App_Experience_APi/',
        method: 'post',
        data,
  
    })
}